if (__DEV__) {
  require('./components/EnginesOverviewContainer');
}

const passthrough = (props) => props.children;

export default (store) => ({
  path: 'engines',

  component: passthrough,

  indexRoute: {
    onEnter: (nextState, replace) => replace('/engines/overview'),
  },

  childRoutes: [
    {
      path: '*',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(
          /* webpackChunkName: "engines" */ './components/EnginesOverviewContainer'
        )
          .then((component) => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },
    },
  ],
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}



// WEBPACK FOOTER //
// ./src/client/plugins/engines/index.js